import * as React from "react";
import { Col, Row, Image } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import Spacer from "../Spacer";

export default function Testimonials() {
	interface Props {
		name: string;
		function: string;
		quote: string;
		image: string;
	}
	function Testimonial(props: Props) {
		return (
			<Row
				xs={1}
				sm={1}
				lg={2}
			>
				<Col className="testimonial">
					<Col>
						<p className="testimonial-quote">"{props.quote}"</p>
						<p>
							<Row>
								<Col>
									<b> {props.name}</b>
									<br />
									{props.function}
								</Col>
							</Row>
						</p>
					</Col>
				</Col>
				<Col className="testimonial-image-col">
					<Image
						src={props.image}
						className="testimonial-image"
						alt="Persoon met EarBud in oor"
					/>
				</Col>
			</Row>
		);
	}

	return (
		<>
			<br />
			<Row >
				<Swiper
					modules={[Pagination, Autoplay]}
					spaceBetween={200}
					slidesPerView={1}
					autoplay={{ pauseOnMouseEnter: true, delay: 10000 }}
					pagination={{ clickable: true, type: "bullets" }}
					loop={true}

				>
					<SwiperSlide>
						<Testimonial
							name="Arnold Leemhuis"
							function="Carpenter, Roald Hans"
							quote="Amazing earbuds with excellent sound quality. They fit perfectly and are very comfortable to wear. Highly recommended!"
							image="images/testimonials/testimonial-arnold.png"
						/>
					</SwiperSlide>
					<SwiperSlide>
						<Testimonial
							name="Lars"
							function="Technical Service, Hoekman Houtindustrie"
							quote="I never want to be without these again. An excellent product."
							image="images/testimonials/testimonial-lars.png"
						/>
					</SwiperSlide>
				</Swiper>
			</Row>
			<br />
			<br />
			<br />
			<br />
		</>
	);
}
